export default __webpack_public_path__ + "static/media/search.1feeb8a6.svg";